module.exports = __webpack_public_path__ + "media/country_flags/sv-b1a8b8f8.png";